import './js/menu.js';
import './js/products';
import './js/gallery';
import './js/scroll-up';
import './js/modal-assortment.js';
import './js/modal-form.js';
